<template>
  <div class="poster-wrapper" :style="{ backgroundImage: shareBgColor }">
    <div class="poster-bg">
      <p class="poster-title">我的留言卡片</p>
      <swiper :options="swiperOption" ref="goodSwiper" v-if="list.length > 0">
        <swiper-slide class="swiper-slide" v-for="(item, index) in list" :key="index">
          <img style="width:7.5rem;" :src="item" />
        </swiper-slide>
        <!-- <div class="swiper-slide">
          <img style="width:7.5rem;" :src="imgUrl2" />
        </div>
        <div class="swiper-slide">
          <img style="width:7.5rem;" :src="imgUrl3" />
        </div> -->
      </swiper>
      <PosterCardImg id="one" :numbers="firstImg" />
      <PosterCardImg id="two" :numbers="secondImg" />
      <PosterCardImg id="three" :numbers="threeImg" />
      <div class="back-btn">
        <div class="btn" @click="goBack"><img src="../../../../assets/images/icon_back.png" alt="" /> 返回</div>
        <div class="long-tagtext"><img src="../../../../assets/images/icon_up.png" alt="" /><span class="text">长按图片保存</span></div>
      </div>
      <div class="poster-bottom"><img src="../../../../assets/images/icon_nfplus.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
import PosterCardImg from "./PosterCardImg/index"
import { mapGetters, mapActions } from "vuex"
import html2canvas from "html2canvas"
import { loadImgArr } from "@/utils/helpers/loadImg"
const POSTER_IMG = require("../../../../assets/images/poster2.png")
export default {
  name: "poster",
  data() {
    var rotate = 0,
      stretch = -30,
      depth = 150,
      modifier = 1
    return {
      swiperOption: {
        // initialSlide: 3,
        autoplay: false,
        loop: false,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate, //slide做3d旋转时Y轴的旋转角度。
          stretch,
          depth,
          modifier,
          slideShadows: false //开启slide阴影。
        }
      },
      list: []
    }
  },
  created() {
    // this.getMyMessageList()
    //this.saveImg()
  },
  components: {
    PosterCardImg
  },
  computed: {
    ...mapGetters({
      shareBgColor: "activityInfo/shareBgColor",
      userInfo: "userInfo/userInfo",
      myMessageList: "activityInfo/myMessageList",
      posterImage: "activityInfo/posterImage",
      fontColor: "activityInfo/fontColor"
    }),
    firstImg() {
      let temp
      if (this.myMessageList && this.myMessageList[0]) {
        temp = this.myMessageList[0]
      } else {
        temp = undefined
      }
      return temp
    },
    secondImg() {
      let temp
      if (this.myMessageList && this.myMessageList[1]) {
        temp = this.myMessageList[1]
      } else {
        temp = undefined
      }
      return temp
    },
    threeImg() {
      let temp
      if (this.myMessageList && this.myMessageList[2]) {
        temp = this.myMessageList[2]
      } else {
        temp = undefined
      }
      return temp
    },
    cardDescColor() {
      function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            }
          : {}
      }
      const { r, g, b } = hexToRgb(this.fontColor)
      return `rgba(${r}, ${g}, ${b}, 0.7)`
    }
  },
  methods: {
    ...mapActions({
      getMyMessageList: "activityInfo/getMyMessageList"
    }),
    goBack() {
      this.$router.push({ path: "/", query: this.$route.query })
    },
    saveImg() {
      const posterList = [this.firstImg, this.secondImg, this.threeImg].filter(item => item)
      const domId = ["#one", "#two", "#three"]
      let arr = posterList.map((item, index) => {
        return this.htmlCanvas(domId[index])
      })
      Promise.all(arr).then(res => {
        this.list = res
      })
    },
    htmlCanvas(id) {
      return new Promise(resolve => {
        let dom = document.querySelector(id)
        html2canvas(dom, {
          useCORS: true,
          x: -9999,
          y: -9999,
          scrollX: 0,
          scrollY: 0,
          dpi: window.devicePixelRatio * 1,
          width: dom.offsetWidth,
          height: dom.offsetHeight
        }).then(canvas => {
          resolve(canvas.toDataURL("image/png"))
        })
      })
    }
  },
  mounted() {
    const imgArr = [this.userInfo.userAvatarImg, POSTER_IMG, this.posterImage]
    loadImgArr(imgArr).then(() => {
      this.saveImg()
    })
  }
}
</script>
<style lang="scss" scoped>
.poster-wrapper {
  width: 7.5rem;
  height: 100%;
  overflow: auto;
}
.poster-bg {
  // background: linear-gradient(-180deg, #b9e4d0 0%, #94d1d3 96%);
  width: 100%;
  min-height: 12.05rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .poster-title {
    height: 0.45rem;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    text-align: center;
    margin: 0.4rem 0;
  }
  .swiper-container {
    width: 100%;
    height: 8.4rem;
    position: absolute;
    left: 0;
    top: 0.4rem;
    bottom: 2rem;
    right: 0;
    margin: auto;
    flex: none;
  }
  .swiper-slide {
    width: 6.5rem;
    height: 8.4rem;
    overflow: hidden;
    background: #ffffff;
    border-radius: 0.2rem;
    box-shadow: 0rem 0rem 0.04rem#ccc;
    img {
      position: absolute;
      left: -0.5rem;
      top: -1.2rem;
      z-index: -1;
    }
  }
  .back-btn {
    position: absolute;
    left: 0rem;
    bottom: 1.8rem;
    margin: 0 auto;
    width: 100%;
    padding: 0 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      padding: 0 0.2rem;
      width: auto;
      height: 0.6rem;
      border-radius: 0.3rem;
      background: #ffffff;
      border: none;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #555555;
      img {
        width: 0.19rem;
        height: 0.19rem;
        margin-right: 0.04rem;
      }
    }
    .long-tagtext {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      img {
        width: 0.18rem;
        height: 0.18rem;
        margin-right: 0.08rem;
      }
      .text {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: 600;
      }
    }
  }
  .poster-bottom {
    width: 100%;
    position: absolute;
    left: 50%;
    bottom: 0.5rem;
    margin-left: -50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1.98rem;
      height: 0.61rem;
    }
  }
  #one,
  #two,
  #three {
    position: absolute;
    left: -9999px;
    top: -9999px;
    z-index: -1;
  }
}
</style>
